export const CART_EVENT_PREFIX = "oc-cart";

// command events (i.e. have not yet been confirmed by backend)
export const CHANGE_ITEM_QUANTITY_COMMAND_EVENT = `${CART_EVENT_PREFIX}-change-item-quantity-command-event`;

// failure events
export const CART_EVENT_FAILURE_EVENT = `${CART_EVENT_PREFIX}-cart-event-failure-event`;
export const CART_REQUEST_FAILURE_EVENT = `${CART_EVENT_PREFIX}-cart-request-failure-event`;

// events (i.e. have been confirmed by backend)
export const ITEM_QUANTITY_CHANGED_EVENT = `${CART_EVENT_PREFIX}-item-quantity-changed-event`;
export const CART_FETCHED_FRESH_EVENT = `${CART_EVENT_PREFIX}-cart-fetched-fresh-event`; // this is a catch-many event which happens when the cart needs to be fetched again completely because something happened (e.g. delivery date change, or bulk add items)

export type CommonStatus = "ACTIVE" | "SAVED" | "SUBMITTED" | "PAYMENT_PENDING" | "ANON";

type BasicCartEvent = {
	cartId: string;
	commonStatus: CommonStatus;
};

type CartCommandEvent = BasicCartEvent & {
	requestId: string;
};

type CartEvent = BasicCartEvent & {
	eventId: string;
};

type QuantityChangeDetail = {
	bundleId: string;
	previousQuantity: number; // the quantity in the cart before the event happened; for weight and weightPerPiece articles, this is a weight
	newQuantity: number; // the quantity in the cart after the event happened; for weight and weightPerPiece articles, this is a weight
};

type ChangeItemQuantityCommandEventDetail = CartCommandEvent & QuantityChangeDetail;
type ItemQuantityChangedEventDetail = CartEvent & QuantityChangeDetail;

type CartEventFailureEventDetail = CartEvent & {
	reason: string | undefined;
};

export const emitChangeItemQuantityCommandEvent = (detail: ChangeItemQuantityCommandEventDetail) => {
	window.dispatchEvent(
		new CustomEvent(CHANGE_ITEM_QUANTITY_COMMAND_EVENT, {
			bubbles: true,
			detail: detail,
		}),
	);
};

export const emitCartEventFailureEvent = (detail: CartEventFailureEventDetail) => {
	window.dispatchEvent(
		new CustomEvent(CART_EVENT_FAILURE_EVENT, {
			bubbles: true,
			detail: detail,
		}),
	);
};
export const emitCartRequestFailureEvent = (detail: BasicCartEvent) => {
	window.dispatchEvent(
		new CustomEvent(CART_REQUEST_FAILURE_EVENT, {
			bubbles: true,
			detail: detail,
		}),
	);
};

export const emitItemQuantityChangedEvent = (detail: ItemQuantityChangedEventDetail) => {
	window.dispatchEvent(
		new CustomEvent(ITEM_QUANTITY_CHANGED_EVENT, {
			bubbles: true,
			detail: detail,
		}),
	);
};
export const emitCartFetchedFreshEvent = (detail: BasicCartEvent) => {
	window.dispatchEvent(
		new CustomEvent(CART_FETCHED_FRESH_EVENT, {
			bubbles: true,
			detail: detail,
		}),
	);
};
